import React, { Component } from "react";
import { Link } from "react-router-dom";
import firebase from "../../firebase";
import md5 from "md5";
import {
	Grid,
	Form,
	Segment,
	Button,
	Header,
	Message,
	Icon
} from "semantic-ui-react";

export default class Register extends Component {
	state = {
		email: "",
		username: "",
		password: "",
		passwordConfirmation: "",
		errors: [],
		loading: false,
		usersRef: firebase.database().ref("users")
	};

	isFormValid = () => {
		let errors = [];
		let error;

		if (this.isFormEmpty(this.state)) {
			error = { message: "Fill in all fields" };
			this.setState({
				errors: errors.concat(error)
			});
			return false;
		} else if (!this.isPasswordValid(this.state)) {
			error = { message: "Password is invalid!" };
			this.setState({
				errors: errors.concat(error)
			});
			return false;
		} else {
			return true;
		}
	};

	isFormEmpty = ({ email, username, password, passwordConfirmation }) => {
		return (
			!username.length ||
			!email.length ||
			!password.length ||
			!passwordConfirmation.length
		);
	};

	isPasswordValid = ({ password, passwordConfirmation }) => {
		if (password.length < 6 || passwordConfirmation.length < 6) {
			return false;
		} else if (passwordConfirmation !== password) {
			return false;
		} else {
			return true;
		}
	};

	displayErrors = errors =>
		errors.map((error, i) => <p key={i}>{error.message}</p>);

	handleInputError = (errors, inputName) => {
		return errors.some(error => error.message.toLowerCase().includes(inputName))
			? "error"
			: "";
	};

	handleChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};

	saveUser = createdUser => {
		return this.state.usersRef.child(createdUser.user.uid).set({
			name: createdUser.user.displayName,
			avatar: createdUser.user.photoURL
		});
	};

	handleSubmit = e => {
		e.preventDefault();
		if (this.isFormValid()) {
			this.setState({
				errors: [],
				loading: true
			});
			firebase
				.auth()
				.createUserWithEmailAndPassword(this.state.email, this.state.password)
				.then(createdUser => {
					console.log(createdUser);
					createdUser.user
						.updateProfile({
							displayName: this.state.username,
							photoURL: `http://gravatar.com/avatar/${md5(
								createdUser.user.email
							)}?d=identicon`
						})

						.then(() => {
							this.saveUser(createdUser).then(() => {
								console.log("saved User");
								this.setState({
									loading: false
								});
							});
						});
				})
				.catch(e => {
					console.error(e);
					this.setState({
						loading: false,
						errors: this.state.errors.concat(e)
					});
				});
		}
	};

	render() {
		const {
			username,
			email,
			password,
			passwordConfirmation,
			errors,
			loading
		} = this.state;
		return (
			<Grid textAlign="center" verticalAlign="middle" className="app">
				<Grid.Column style={{ maxWidth: 450 }}>
					<Header as="h2" icon color="orange" textAlign="center">
						<Icon name="puzzle piece" color="orange" />
						Register to DevChat
					</Header>
					<Form size="large" onSubmit={this.handleSubmit}>
						<Segment stacked>
							<Form.Input
								fluid
								name="username"
								icon="user"
								iconPosition="left"
								placeholder="Username"
								onChange={this.handleChange}
								className={this.handleInputError(errors, "username")}
								type="text"
								value={username}
							/>
							<Form.Input
								fluid
								name="email"
								icon="mail"
								iconPosition="left"
								placeholder="Email Address"
								onChange={this.handleChange}
								type="email"
								className={this.handleInputError(errors, "email")}
								value={email}
							/>
							<Form.Input
								fluid
								name="password"
								icon="lock"
								iconPosition="left"
								placeholder="Password"
								onChange={this.handleChange}
								className={this.handleInputError(errors, "password")}
								type="password"
								value={password}
							/>
							<Form.Input
								fluid
								name="passwordConfirmation"
								icon="repeat"
								iconPosition="left"
								placeholder="Confirm Password"
								onChange={this.handleChange}
								className={this.handleInputError(errors, "password")}
								type="password"
								value={passwordConfirmation}
							/>

							<Button
								disabled={loading}
								className={loading ? "loading" : ""}
								color="orange"
								fluid
								size="large"
							>
								Submit
							</Button>
						</Segment>
					</Form>
					{errors.length > 0 && (
						<Message error>
							<h1>Error</h1>
							{this.displayErrors(errors)}
						</Message>
					)}
					<Message>
						Already Registered? <Link to="/login">Login</Link>
					</Message>
				</Grid.Column>
			</Grid>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register.js